import { Route, createPageRoute, AppId } from '@lumapps/router';
import { bigIntToHexUUID } from '@lumapps/utils/string/bigIntToHexUUID';

export const groupChatInfoViewRoute: Route = createPageRoute({
    slug: 'chats/:groupChatId/info',
    appId: AppId.frontOffice,
});

export const oneOnOneMessageInfoViewRoute: Route = createPageRoute({
    slug: 'chats/user/:userId/messages/:messageId/info',
    appId: AppId.frontOffice,
});

export const groupMessageInfoViewRoute: Route = createPageRoute({
    slug: 'chats/:groupChatId/messages/:messageId/info',
    appId: AppId.frontOffice,
});

export const oneOnOneMessageRoute: Route = createPageRoute({
    slug: 'chats/user/:userId/messages/:messageId',
    appId: AppId.frontOffice,
});

export const groupChatMessageRoute: Route = createPageRoute({
    slug: 'chats/:groupChatId/messages/:messageId',
    appId: AppId.frontOffice,
});

export const oneOnOneChatRoute: Route = createPageRoute({
    slug: 'chats/user/:userId',
    appId: AppId.frontOffice,
});

export const groupChatRoute: Route = createPageRoute({
    slug: 'chats/:chatId',
    appId: AppId.frontOffice,
});

export const chatsRoute: Route = createPageRoute({
    slug: 'chats',
    appId: AppId.frontOffice,
});

export const smartGroupChatsManagementRoute: Route = createPageRoute({
    slug: 'chats/smart-group-chats-management',
    appId: AppId.frontOffice,
});

export const chatsRoutes: Route[] = [
    groupChatInfoViewRoute,
    oneOnOneMessageInfoViewRoute,
    groupMessageInfoViewRoute,
    oneOnOneMessageRoute,
    groupChatMessageRoute,
    oneOnOneChatRoute,
    groupChatRoute,
    chatsRoute,
];

export const oneOnOneChatRouteForUser = (bigIntUserId: string): Route | undefined => {
    const userId = bigIntToHexUUID(bigIntUserId);
    if (!userId) {
        return undefined;
    }
    return { ...oneOnOneChatRoute, params: { userId } };
};
